import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const MoveUpDownloadListener: EventHandler<number> = async (event: IpcMainInvokeEvent, content: number): Promise<void> => {
    await eventDispatcher.dispatch('MoveUpDownloadAction', content);
    await eventDispatcher.dispatch('ChangeDownloadPositionsAction');
}

export default MoveUpDownloadListener;